var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"question-checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }